import { render, staticRenderFns } from "./SimpleQuestionLayout.vue?vue&type=template&id=4b395330&scoped=true&"
import script from "./SimpleQuestionLayout.vue?vue&type=script&lang=js&"
export * from "./SimpleQuestionLayout.vue?vue&type=script&lang=js&"
import style0 from "./SimpleQuestionLayout.vue?vue&type=style&index=0&id=4b395330&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b395330",
  null
  
)

export default component.exports